"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _Image = require("../Image");

var _useComponentStyle = require("../theme/useComponentStyle");

var _styleHelpers = require("../styleHelpers");

var _useCustomStyles = require("../utils/useCustomStyles");

var _baseStyle = require("../shared/baseStyle");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var AvatarImage = (0, _styledComponents.default)(_Image.Image).withConfig({
  displayName: "Avatar__AvatarImage",
  componentId: "sc-1rbojgv-0"
})(["", " ", ""], _baseStyle.baseStyle, (0, _styleHelpers.conditionalStyles)('variant', {
  square: (0, _styledComponents.css)(["border-radius:", "px;"], (0, _styleHelpers.getComponentStyle)('avatar.square.borderRadius')),
  circle: (0, _styledComponents.css)(["border-radius:50%;"])
}));

var _StyledAvatarImage = (0, _styledComponents.default)(AvatarImage).withConfig({
  displayName: "Avatar___StyledAvatarImage",
  componentId: "sc-1rbojgv-1"
})(["", ""], function (p) {
  return p._css;
});

var Avatar = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      src = _ref.src,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'square' : _ref$variant,
      customStyles = _ref.customStyles,
      props = _objectWithoutProperties(_ref, ["className", "src", "size", "variant", "customStyles"]);

  var dimension = (0, _useComponentStyle.useComponentStyle)('avatar.size.{size}', {
    size: size
  });
  var getCustomStyles = (0, _useCustomStyles.useCustomStyles)('avatar.styles', customStyles);
  return /*#__PURE__*/_react.default.createElement(_StyledAvatarImage, _extends({
    ref: ref
  }, props, {
    variant: variant,
    size: size,
    width: dimension,
    height: dimension,
    className: className,
    src: src,
    _css: getCustomStyles(variant)
  }));
});
exports.Avatar = Avatar;